import { CarItemDto } from '@/api/generated';
import { CarAddModel } from '@/views/cars/list/components/dialog/model/CarAdd.model.ts';
import { CarsListSearchFormModel } from '@/views/cars/list/model/CarsListSearchForm.model.ts';

export type CarsListTranslation = {
  dialog: {
    add: {
      button: {
        cancel: string;
        save: string;
        saveAndAdd: string;
      };
      form: Record<keyof CarAddModel, string>;
      title: {
        create: string;
        update: string;
      };
    };
  };
  header: {
    button: {
      add: string;
    };
  };
  table: {
    body: Record<keyof Omit<CarItemDto, 'carId'>, string>;
    head: Record<keyof CarsListSearchFormModel, string>;
  };
};

export const carsListTranslation: CarsListTranslation = {
  dialog: {
    add: {
      button: {
        cancel: 'Anuluj',
        save: 'Zapisz',
        saveAndAdd: 'Zapisz i dodaj kolejny',
      },
      form: {
        licensePlate: 'Nr rejestracyjny',
        mileage: 'Przebieg',
        model: 'Model',
        note: 'Notatka',
        status: 'Status',
        type: 'Rodzaj',
        vin: 'Nr VIN',
        year: 'Rocznik',
      },
      title: {
        create: 'Dodaj auto',
        update: 'Zaktualizuj auto',
      },
    },
  },
  header: {
    button: {
      add: 'Dodaj',
    },
  },
  table: {
    body: {
      licensePlate: 'Nr rejestracyjny',
      model: 'Model',
      status: 'Status',
      type: 'Rodzaj',
    },
    head: {
      fullTextSearchInput: 'Szukaj',
      status: 'Status',
      types: 'Rodzaj',
    },
  },
};
